/* global SIR */
import { useEffect, useRef } from 'react';
import { useSportRadarScriptUrl } from '~SpectateStore/hooks/scoreboardHooks';
import { getLanguageCode } from '~shared/utils/user';
import { SPORTRADAR_WIDGET_LANG } from '~shared/locales/customLanguageMappings';

// Set up and API for SportRadar widget can be found in
// https://widgets.sir.sportradar.com/docs/tutorial-getting-started.html
export const useSportradarWidget = (eventId, callback) => {
    const userLang = getLanguageCode();
    const scriptUrl = useSportRadarScriptUrl();
    const widgetWrapperRef = useRef();
    const widgetName = 'sportradar-widget';
    const widgetLang = SPORTRADAR_WIDGET_LANG[userLang];

    const widgetProps = {
        matchId: `m${eventId}`,
        tabsPosition: 'top',
        scoreboard: 'disable',
        layout: 'double',
        onTrack: (triggered_event, widgetEventData) => {
           return triggered_event === 'data_change'
                ? callback && callback(widgetEventData)
                : null;
        },
    };

    useEffect(() => {
        const script = document.createElement('script');

        if (widgetWrapperRef.current) {
            script.src = scriptUrl;
            script.async = true;
            script.dataset.srLanguage = widgetLang;
            script.onload = () => {
                if (SIR) {
                    SIR('addWidget', `#${widgetName}`, 'match.lmtPlus', widgetProps);
                }
            };

            widgetWrapperRef.current.appendChild(script);
        }

        return () => {
            if (SIR) {
                SIR('removeWidget', `#${widgetName}`);
            }

            widgetWrapperRef.current.removeChild(script);
        };
    }, [widgetWrapperRef.current]);

    return { widgetWrapperRef, widgetName };
};
